import { FC, ReactNode } from 'react';

import { Box, StyleProps } from '@bonusly/design-system';

interface Props extends StyleProps {
	children: ReactNode;
}

export const NavGroup: FC<Props> = (props) => <Box px={1} {...props} />;
